module.exports = __webpack_public_path__ + "img/icon_exclamation_mark_w.e21e2fc8.svg";